import {
  Handshake,
  Home,
  Group,
  Person,
  RssFeed,
  Subscriptions,
  Message,
  RateReview,
  PhotoLibrary,
  Assignment,
  TrendingUp,
  Work,
  VolunteerActivism,
  Business,
  Description,
} from "@mui/icons-material";

import { Menu } from "../model/menu";

export const menus: Menu[] = [
  {
    name: "Dashboard",
    path: "/",
    icon: Home,
  },
  // {
  //   name: "User",
  //   path: "/users",
  //   icon: Person, // Single user
  // },
  {
    name: "Blog",
    path: "/blogs",
    icon: RssFeed, // RSS feed icon fits "blog"
  },
  {
    name: "Gallery",
    path: "/galleries",
    icon: PhotoLibrary, // Photo library icon for galleries
  },
  {
    name: "Events",
    path: "/programs",
    icon: Assignment, // Assignment icon for programs
  },
  // {
  //   name: "Volunteers",
  //   path: "/volunteers",
  //   icon: VolunteerActivism, // Volunteer activism icon
  // },
  // {
  //   name: "CSO Members",
  //   path: "/cso-members",
  //   icon: Business, // Business icon for CSO members
  // },
  // {
  //   name: "Vacancies",
  //   path: "/vacancies",
  //   icon: Work, // Work icon for vacancies
  // },
  {
    name: "Testimonial",
    path: "/testimonials",
    icon: RateReview, // Review/rating icon for testimonials
  },
  {
    name: "Partners",
    path: "/partners",
    icon: Handshake, // Handshake icon for partners
  },
  {
    name: "Team",
    path: "/teams",
    icon: Group, // Group/team icon
  },
  {
    name: "Subscribers",
    path: "/subscribers",
    icon: Subscriptions, // Subscription icon
  },
  {
    name: "Newsletters",
    path: "/newsletters",
    icon: RssFeed, // RSS feed icon for newsletters
  },
  {
    name: "Messages",
    path: "/messages",
    icon: Message, // Message icon
  },
  {
    name: "Resource Documents",
    path: "/resource-documents",
    icon: Description, // Document icon
  },
];


